export default function (file: any) {
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
        reader.readAsDataURL(file);

        reader.onerror = () => {
            reader.abort();
            reject(new DOMException('Problem parsing input file.'));
        };

        reader.onloadend = (e: any) => {
            let result = reader.result;
            resolve(result);
        };
    });
}
